var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 54,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDDD8",
    fillRule: "evenodd",
    d: "M0 54V16h14.546v4H4v30h32V20H25.454v-4H40v38H0Zm10-44h5l3-3c.134-.134 0 26 0 26h4s-.151-26.151 0-26l3 3h5L20 0 10 10Z",
    clipRule: "evenodd"
  })));
};
export { SvgShare as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA0MCA1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDU0VjE2SDE0LjU0NTVWMjBINFY1MEgzNlYyMEgyNS40NTQ1VjE2SDQwVjU0SDBaTTEwIDEwSDE1QzE1IDEwIDE2LjMzMzYgOC42NjY0MSAxOCA3QzE4LjEzNDEgNi44NjU4NSAxOCAzMyAxOCAzM0gyMkMyMiAzMyAyMS44NDkgNi44NDkgMjIgN0wyNSAxMEgzMEwyMCAwTDEwIDEwWiIgZmlsbD0iI0RFREREOCIvPgo8L3N2Zz4K";